<template>
    <h2>{{$t('exportModel')}}</h2>
  </template>
  
  <script>
  export default {
      name: 'export-model'
  }
  </script>
  
  <style>
  
  </style>
  